import config from 'const/config'

const isProductionEnv = (): boolean => String(config.APP_ENV) === 'production'

export default isProductionEnv
